const orderSendTypeMessages = {
  A_DOMICILIO: "Envío a domicilio",
  RETIRO_LOCAL: "Retira en local"
};

export default orderSendTypeMessages;
